import React, { Component } from "react";
import { Grid, Paper } from "@material-ui/core";
import LeftPanel from "./LeftPanel";
import RightPanel from "./RightPanel";
import AddButton from "./AddButton";

export default class AdminITEP extends Component {
  state = {
    selectedNode: null,
    refreshKey: 0, // force re-render tree after add/update/delete
  };

  // When user clicks on any tree item
  handleSelectNode = (node) => {
    this.setState({ selectedNode: node });
  };

  // Called after add/update/delete to refresh the tree
  refreshTree = () => {
    this.setState({ refreshKey: this.state.refreshKey + 1 });
  };

  render() {
    return (
      <div style={{ padding: 20 }}>
        <h2 style={{ marginBottom: 20 }}>ITEP Content Management</h2>

        <Grid container spacing={2}>
          {/* LEFT TREE PANEL */}
          <Grid item xs={12} sm={4} md={3}>
            <Paper style={{ padding: 15, height: "80vh", overflowY: "auto" }}>
              <LeftPanel
                key={this.state.refreshKey} // Refresh tree when changed
                onSelect={this.handleSelectNode}
                apikey={this.props.apikey}
              />
              <AddButton floating={false} parentId={null} refresh={this.refreshTree} apikey={this.props.apikey} />
            </Paper>
          </Grid>

          {/* RIGHT EDITOR PANEL */}
          <Grid item xs={12} sm={8} md={9}>
            <Paper style={{ padding: 20, minHeight: "80vh" }}>
              <RightPanel
                selected={this.state.selectedNode}
                refresh={this.refreshTree}
                apikey={this.props.apikey}
              />
            </Paper>
          </Grid>
        </Grid>

        {/* ADD NEW ITEM FLOATING BUTTON */}
        <AddButton floating={true} parentId={(this.state.selectedNode ? this.state.selectedNode.id : null) || null} refresh={this.refreshTree} apikey={this.props.apikey} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/AdminITEP/AdminITEP.js